/* eslint-disable react/jsx-no-leaked-render */
import type { FC } from 'react';
import ImageCarousel from '../../../shared/img-carousel';
import SVGGradientFiller from '../../../shared/svg-gradient-filler';
import ProductBrochure from '../brochure';
import EnquireProduct from '../enquiry';
import { Link } from 'gatsby';
import { Play } from 'lucide-react';

const ProductDetailAbout: FC<{
  title: string;
  description: string;
  images: string[];
  brochure?: { url: string; name: string };
  id: string;
  youtubePlaylist?: string;
}> = ({ title, description, images, brochure, youtubePlaylist }) => {
  return (
    <div className="pd-abt py-10 mt-8 bg-[#F4F4F4]">
      <div className="container px-6 mx-auto">
        <div className="grid grid-cols-2 gap-10 max-lg:grid-cols-1 items-center justify-between">
          <div>
            <h1 className="text-4xl uppercase font-bold max-sm:text-2xl seoTile">
              {title}
            </h1>
            <p className="my-5 font-normal text-base leading-7 whitespace-pre-wrap text-[#171B24] seoDescription">
              {description}
            </p>

            <div className="flex space-x-4 items-center">
              <EnquireProduct product={title} />
              {brochure ? (
                <ProductBrochure link={brochure.url} name={title} />
              ) : null}
            </div>
            <div className="flex space-x-4 items-start mt-2 ">
              {youtubePlaylist && (
                <Link
                  className="flex items-center font-bold space-x-2 justify-between text-gray-50 bg-action-btn p-2 rounded-md
               transition-smooth hover:-translate-y-1 min-w-80 text-center text-sm"
                  target="_blank"
                  to={youtubePlaylist}
                >
                  Video of {title} <div className="border-2 pl-2 pt-[6px] w-8 h-8 text-center flex-col justify-center items-center border-white rounded-full">
              <Play className="w-4 h-4 text-white opacity-100 group-hover:opacity-100 transition-opacity" />
            </div>
                </Link>
              )}
            </div>
          </div>

          <div className="w-full md:w-[80%] ms-auto">
            <ImageCarousel
              className="w-full object-cover max-w-full seoFeaturedImage"
              images={images}
            />
          </div>
        </div>
      </div>
      <SVGGradientFiller
        id="product-detail-btn"
        stop={{ from: '#990400', via: '#FF3D00', to: '#FF8A00' }}
      />
    </div>
  );
};

export default ProductDetailAbout;
